import Config from "../constant/Config";
import { fetchJsonIfOk } from "./ServiceUtils";

export const getStageConfig = async (minigameId, stageStateId = null, roundStageId = null) => {
  const url = stageStateId === null || stageStateId === undefined
    ? `${Config.apiurl}/minigame/${minigameId}/stage/config`
    : `${Config.apiurl}/minigame/${minigameId}/stage/${stageStateId}/config?roundStageId=${roundStageId}`;
  return await fetchJsonIfOk(url);
}

export const getMinigames = async () => {
  return await fetchJsonIfOk(`${Config.apiurl}/minigames`);
}
